import React from 'react';
import Layout from '@codedrop/layout/esm/layout';
import Heading from '@codedrop/typography/esm/heading';

const Customers = ({
  customers
}) => {
  const Graphic = file => {
    const graphicFile = require("../images/".concat(file.file));

    return graphicFile.default();
  };

  return /*#__PURE__*/React.createElement(Layout, {
    className: "section--top-l section--bottom-l"
  }, /*#__PURE__*/React.createElement("div", {
    className: "customers"
  }, /*#__PURE__*/React.createElement(Heading, {
    tag: "h3",
    headingClass: "heading--m text--secondary text--centered"
  }, customers.title), /*#__PURE__*/React.createElement("div", {
    className: "grid"
  }, customers.items.map((item, index) => {
    const file = item.url;
    return /*#__PURE__*/React.createElement("div", {
      className: "grid__col grid--3-col",
      key: "customers-".concat(index)
    }, /*#__PURE__*/React.createElement("figure", {
      className: "customers__logo"
    }, /*#__PURE__*/React.createElement("a", {
      href: item.linkUrl,
      target: "_blank"
    }, /*#__PURE__*/React.createElement(Graphic, {
      file: file
    }))));
  }))));
};

Customers.displayName = 'Customers';
export default Customers;